import { useControllableState } from '../hooks/use-controllable-state';
import { Button, ButtonProps } from '../button/button';
import { Text } from '../text/text';
import { Flex } from '../flex/flex';

export interface CounterProps {
  value?: number;
  min?: number;
  max?: number;
  onChange?: (x: number) => void;
  defaultValue?: number;
}

const StyledButton = ({ children, ...rest }: ButtonProps) => {
  return (
    <Button css={{ borderRadius: '50%', padding: 0, lineHeight: '24px' }} size="counter" {...rest}>
      {children}
    </Button>
  );
};
export function useCounter({
  defaultValue = 1,
  value: valueFromProps,
  onChange: onChangeFromProps,
  min = Number.NEGATIVE_INFINITY,
  max = Number.POSITIVE_INFINITY,
}: CounterProps) {
  const [value, setValue] = useControllableState({
    defaultValue,
    valueFromProps,
    onChangeFromProps,
  });
  const decrement = () => setValue(Math.max(min, value - 1));
  const increment = () => setValue(Math.min(max, value + 1));
  const canDecrement = value <= min;
  const canIncrement = value >= max;
  return { value, setValue, decrement, increment, canDecrement, canIncrement };
}

export function Counter(props: CounterProps) {
  const { value, decrement, increment, canDecrement, canIncrement } = useCounter(props);
  return (
    <Flex style={{ alignItems: 'center' }} data-component="Counter">
      <StyledButton onClick={decrement} disabled={canDecrement}>
        -
      </StyledButton>
      <Flex style={{ justifyContent: 'center', alignItems: 'center', width: 38 }}>
        <Text>{value}</Text>
      </Flex>
      <StyledButton onClick={increment} disabled={canIncrement}>
        +
      </StyledButton>
    </Flex>
  );
}
